
<div class="flex flex-row justify-between items-center gap-2 font-rubik">
  <button
    class="hamburger-menu-button border rounded-full flex items-center justify-center"
    @click="toggleMenu()"
  >
    <img
      class=""
      src="@/images/header/hamburger-menu.svg"
      alt="Open menu"
    />
  </button>
</div>
